/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SuccessToast extends Component {
  static propTypes = {
    options: PropTypes.shape({
      display: PropTypes.bool,
      message: PropTypes.string,
      timeout: PropTypes.number,
    }),
    dismissCartConvertToast: PropTypes.func.isRequired,
  }

  static defaultProps = {
    options: {
      display: false,
      message: '',
      timeout: 0,
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      display: props.options.display,
    };
  }

  componentDidMount() {
    this.setDimissTimeout();
  }

  componentWillReceiveProps(newProps) {
    this.setState({ display: newProps.options.display });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.options.timeout !== this.props.options.timeout) {
      this.setDimissTimeout();
    }
  }

  setDimissTimeout = () => {
    if (this.props.options.timeout > 0) {
      setTimeout(() => {
        this.props.dismissCartConvertToast();
      }, this.props.options.timeout);
    }
  }


  render = () => (
    (this.state.display) &&
    <div className="banner success">
      <svg height="27" viewBox="0 0 30 30" width="27" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
      <span className="message" dangerouslySetInnerHTML={{ __html: this.props.options.message }} />
      <svg
        className="close"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => this.props.dismissCartConvertToast()}
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>

    </div>
  )
}

export default SuccessToast;
